import type { OperatorTabletWorkspace } from "./useOperatorTabletWorkspace";
import { OperatorCurrentJob } from "./OperatorCurrentJob";
import { OperatorTabletDialogs } from "./OperatorTabletDialogs";
import { OperatorHistoryPanel } from "./OperatorHistoryPanel";
import { OperatorMachineControls } from "../OperatorMachineControls";
import { OperatorCompletedJobs } from "../OperatorCompletedJobs";
import { OperatorNotice } from "../OperatorNotice";
import { OperatorWorkOrdersDialog } from "../OperatorWorkOrdersDialog";
import { OperatorTerminalHeader as KioskHeader } from "../terminal/OperatorTerminalHeader";
import { OperationalNotificationStrip } from "../terminal/OperationalNotificationStrip";
import { TouchEmpty } from "./OperatorRunStatus";
import { OperatorHandoverDialog } from "../terminal/OperatorHandoverDialog";

export function OperatorTabletView({ shell, currentJob, dialogs, historyPanel }: OperatorTabletWorkspace) {
  const { selected, openDowntime, terminalContext, user, available, setCompletedJobsOpen, lockTerminal, machineCommands, reference, setWorkOrdersOpen, onMachineLogout, completedJobsOpen, loading, loadError, operationTerminalCode, load, handoverOpen, visibleDowntimeReason, setHandoverOpen, onMachineSessionChanged, notify, workOrdersOpen, refreshWorkOrders, acceptStartedRun, notice, updatedAt, quantityWrites, setPendingWritesOpen, selectedNotifications } = shell;
  return (
    <div className={`operator-tablet operator-case-workspace${selected?.status === "ACTIVE" && openDowntime ? " is-downtime-workspace" : ""}${selected?.status === "ACTIVE" && !openDowntime && selected.planItemKind !== "ACTIVITY" ? " is-compact-production" : ""}`}>
      <KioskHeader
        label={terminalContext.terminal.lineName ?? terminalContext.terminal.displayName}
        hours={terminalContext.shift.shiftHours}
        user={user}
        displayName={terminalContext.session?.operatorName}
        terminalName={terminalContext.terminal.displayName}
        terminalCode={terminalContext.terminal.terminalCode}
        operatingDay={{
          date: terminalContext.shift.shiftDate,
          completedCount: available.filter((run) => run.status === "COMPLETED" && run.disposition !== "CANCELLED").length,
          onCompleted: () => setCompletedJobsOpen(true),
        }}
        onLock={lockTerminal}
        machineControls={<OperatorMachineControls workspace={machineCommands} />}
        onActions={reference ? () => setWorkOrdersOpen(true) : undefined}
        onLogout={onMachineLogout}
      />
      {completedJobsOpen ? <OperatorCompletedJobs runs={available} loading={loading} error={loadError} terminalCode={operationTerminalCode} sessionId={terminalContext.session?.id ?? ""} operatorId={terminalContext.session?.operatorId ?? ""} preview={Boolean(user.preview)} reasons={reference?.reasons ?? []} onSaved={() => void load(true)} onRefresh={() => void load(true)} onClose={() => setCompletedJobsOpen(false)} /> : null}
      {handoverOpen && !openDowntime && !visibleDowntimeReason ? <OperatorHandoverDialog key={terminalContext.session?.id} context={terminalContext} onClose={() => setHandoverOpen(false)} onCompleted={onMachineSessionChanged} notify={notify} /> : null}
      {workOrdersOpen && reference && !openDowntime && !visibleDowntimeReason ? <OperatorWorkOrdersDialog
        key={terminalContext.session?.id}
        context={terminalContext} activeRun={available.find((run) => run.status === "ACTIVE") ?? null}
        onClose={() => setWorkOrdersOpen(false)}
        onHandover={() => { setWorkOrdersOpen(false); setHandoverOpen(true); }}
        onRefresh={refreshWorkOrders}
        onStarted={acceptStartedRun}
      /> : null}
      <main className="operator-tablet-main">
        <div className="operator-notice-slot">
          {notice ? <OperatorNotice key={selected?.id} notice={{ ...notice, compact: true }} inline /> : <p className="operator-ready-status">{updatedAt ? `Son sunucu doğrulaması ${new Date(updatedAt).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}` : "Üretim bilgileri doğrulanıyor"}</p>}
        </div>
        {quantityWrites.items.length > 0 || quantityWrites.storageError ? <div className="operator-pending-summary" role="status">
          <span>{quantityWrites.storageError ? "Cihazdaki kayıtlar doğrulanamadı" : `${quantityWrites.items.length} kayıt sunucu onayı bekliyor`}</span>
          <button type="button" onClick={() => setPendingWritesOpen(true)}>İncele</button>
        </div> : null}
        {selected && selectedNotifications[0]?.runId === selected.id && selectedNotifications[0]?.severity === "WARNING"
          ? null
          : <OperationalNotificationStrip items={selectedNotifications} mode="operator" />}
        {loading ? (
          <TouchEmpty
            title="İşler hazırlanıyor"
            text="Aktif vardiyanın üretim işleri yükleniyor."
          />
        ) : !selected ? (
          <TouchEmpty
            title={loadError ? "Üretim bilgileri yüklenemedi" : "Açık iş emri yok"}
            text={loadError
              ? "Sunucu bağlantısını kontrol edip yeniden deneyin. Hiçbir iş otomatik başlatılmaz veya değiştirilmez."
              : "İş emri numarasını girerek ürünü ve plan miktarını doğrulayıp üretimi başlatın."}
            actionLabel={loadError ? "Tekrar dene" : "İş emri başlat"}
            onAction={loadError ? () => void load() : () => setWorkOrdersOpen(true)}
          />
        ) : (
          <OperatorCurrentJob {...currentJob} />
        )}
      </main>
      <OperatorTabletDialogs {...dialogs} />
      <OperatorHistoryPanel {...historyPanel} />
    </div>
  );
}
